<template>
  <div class="insights-unusual-activity-upsell-banner">
    <section class="info">
      <h4 class="title">
        <svg
          class="title-icon"
          width="16"
          height="23"
          viewBox="17 15 22 27"
          fill="none"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M28 20.5417C25.5936 20.5417 23.6364 22.448 23.6364 24.7917C23.6364 25.183 23.9618 25.5 24.3636 25.5C24.7655 25.5 25.0909 25.183 25.0909 24.7917C25.0909 23.2289 26.3964 21.9583 28 21.9583C28.4018 21.9583 28.7273 21.6414 28.7273 21.25C28.7273 20.8586 28.4018 20.5417 28 20.5417ZM24.3664 37.3278C24.3664 37.4673 24.4086 37.6032 24.4882 37.7192L25.6023 39.3501C25.7373 39.5476 25.9645 39.6662 26.2077 39.6662H29.7918C30.0355 39.6662 30.2627 39.5476 30.3973 39.3501L31.5114 37.7192C31.5905 37.6032 31.6327 37.4668 31.6332 37.3278L31.6355 35.4162H24.3645L24.3664 37.3278ZM28 17C23.3509 17 20 20.6732 20 24.7917C20 26.756 20.7477 28.548 21.98 29.9173C22.7364 30.758 23.9227 32.5205 24.3627 33.9973V34H26.5445V33.9947C26.5441 33.7835 26.5118 33.5737 26.4468 33.3718C26.1927 32.5833 25.4095 30.5044 23.6209 28.5166C22.6873 27.4793 22.1882 26.1636 22.1841 24.7917C22.175 21.5316 24.8964 19.125 28 19.125C31.2082 19.125 33.8182 21.667 33.8182 24.7917C33.8182 26.1627 33.3073 27.4855 32.3795 28.5166C30.6018 30.4915 29.815 32.5661 29.5568 33.3625C29.4902 33.5673 29.4562 33.7808 29.4559 33.9956V34H31.6377V33.9978C32.0777 32.5205 33.2641 30.758 34.0205 29.9178C35.2523 28.548 36 26.756 36 24.7917C36 20.4885 32.4182 17 28 17Z"
          />
        </svg>
        Unusual activities with Insights
      </h4>
      <p class="description">
        Identify irregular work patterns, such as software that mimics keyboard or mouse movements to generate
        artificial activity. Add the Insights add-on to get access.
      </p>
      <div class="cta">
        <AppButton
          v-if="canManageBilling"
          data-qa="ua-upsell-unlock-insights"
          type="primary"
          size="sm"
          modifiers="ua-upsell-cta ua-upsell-primary-cta"
          @click="openUnlockInsightsDialog"
        >
          Unlock Insights add-on
        </AppButton>
        <AppButton
          data-qa="ua-upsell-book-consultation"
          type="secondary"
          size="sm"
          modifiers="ua-upsell-cta ua-upsell-secondary-cta"
          @click="openBookConsultation"
        >
          Book free consultation
        </AppButton>
      </div>
    </section>
    <img
      class="illustration"
      :src="illustrationSrc"
      alt=""
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppButton from '~/components/AppButton.vue';
import { INSIGHTS_BANNER_UNUSUAL_ACTIVITY } from '~/rails_assets';

const BOOK_CONSULTATION_URL = 'https://meetings.hubspot.com/diogo-silveira1/insights-demo';

export default {
  name: 'InsightsUnusualActivityUpsellBanner',
  components: { AppButton },
  data: () => ({
    bookConsultationUrl: BOOK_CONSULTATION_URL,
    trackingBanner: 'ua_page_with_insights',
  }),
  computed: {
    ...mapGetters(['canManageBilling', 'organizationId']),
    illustrationSrc() {
      return INSIGHTS_BANNER_UNUSUAL_ACTIVITY;
    },
  },
  methods: {
    openUnlockInsightsDialog() {
      window.analytics?.track('Unlock insights add-on clicked', { banner: this.trackingBanner });
      AjaxDialog.run(`/organizations/${this.organizationId}/insights/cta_dialog.dialog?source=ua_page`);
      window.analytics?.track('Unlock insights modal viewed', { page: 'unusual_activity' });
    },
    openBookConsultation() {
      window.analytics?.track('Book a free consultation clicked', { banner: this.trackingBanner });
      window.open(this.bookConsultationUrl, '_blank', 'noopener');
    },
  },
};
</script>
